import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class Unit {
  create = async (unit: any) => {
    await axios.post<any>(`${API_URL}item-unit`, unit)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  edit = async (unit: any, code: any) => {
    await axios.put<any>(`${API_URL}item-unit/${code}`, unit)
      .catch((e) => {
        const { message } = e.response.data;
        if (message.errorInfo) throw message.errorInfo[2];
        else throw e.message;
      });
  };

  get = async (code: any) => {
    const response = await axios.get<any>(`${API_URL}item-unit/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.unit;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}item-unit`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.unit;
  };
}

export default new Unit();
